import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const clientIdSelector = (state: AppState) => state.userData.clientId;
export const useClientIdSelector = () => useSelector<number | null>(clientIdSelector);
